var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5535_38893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3307 2.66704V6.66704M15.3307 6.66704H11.3307M15.3307 6.66704L12.2374 3.76038C11.5209 3.04352 10.6345 2.51985 9.66086 2.23823C8.68723 1.9566 7.65813 1.92621 6.66959 2.14988C5.68104 2.37355 4.76526 2.844 4.00771 3.51732C3.25015 4.19064 2.67551 5.0449 2.3374 6.00038M0.664062 13.3337V9.33371M0.664062 9.33371H4.66406M0.664062 9.33371L3.7574 12.2404C4.47389 12.9572 5.36031 13.4809 6.33393 13.7625C7.30756 14.0441 8.33666 14.0745 9.3252 13.8509C10.3138 13.6272 11.2295 13.1568 11.9871 12.4834C12.7446 11.8101 13.3193 10.9559 13.6574 10.0004",
    stroke: "#F9F9F9",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5535_38893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIco);
export default __webpack_public_path__ + "static/media/refresh_ico.8195922b11a4a3064d365b06527feebe.svg";
export { ForwardRef as ReactComponent };